function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from 'react';
import { pure } from 'recompose';
import SvgIcon from "../../SvgIcon";

var SvgSmallChevronUp = function SvgSmallChevronUp(_ref) {
  var _ref$title = _ref.title,
      title = _ref$title === void 0 ? 'Up' : _ref$title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement(SvgIcon, _extends({
    title: title
  }, props, {
    viewBox: "0 0 12 12"
  }), React.createElement("g", null, React.createElement("polygon", {
    transform: "translate(6.000000, 6.000000) scale(1, -1) translate(-6.000000, -6.000000) ",
    points: "2.49809783 3 1 4.39700133 6 9 11 4.39700133 9.50190217 3 6 6.22385021"
  })));
};

SvgSmallChevronUp = pure(SvgSmallChevronUp);
SvgSmallChevronUp.displayName = 'SvgSmallChevronUp';
export default SvgSmallChevronUp;